/* eslint-disable no-console */
const LOG_LEVEL = process.env.NODE_ENV === "production" ? "error" : "log";
const NO_OP = () => null;

/** Logger which outputs to the browser console */
export class ConsoleLogger {
  error: { (...data: any[]): void; (message?: any, ...optionalParams: any[]): void };

  warn: () => void;

  log: (value: string) => void;

  constructor(options: any) {
    const { level } = options || {};

    this.error = console.error.bind(console);

    if (level === "error") {
      this.warn = NO_OP;
      this.log = NO_OP;

      return;
    }

    this.warn = console.warn.bind(console);

    if (level === "warn") {
      this.log = NO_OP;

      return;
    }

    this.log = console.log.bind(console);
  }
}

export const logger = new ConsoleLogger({ level: LOG_LEVEL });
